import React, { useEffect, useState } from "react";
import {
  Checkbox,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";
import ImageUpload from "../ImageUpload/ImageUpload";
import { useDispatch, useSelector } from "react-redux";
import {
  addNewProduct,
  clearData,
  editProduct,
} from "../../../Redux/ProductRedux";
import toast from "react-hot-toast";
import ConfirmationDialog from "../ConfirmationDialog";
import { getAllCategory } from "../../../Redux/CategoryRedux";

const AddProduct = ({ setShowForm }) => {
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem("user"));

  const sellerId = user.userId;
  const { selectedProductRow } = useSelector((state) => state.productRedux);
  const { allCategory } = useSelector((state) => state.categoryRedux);
  const [isEditing, setIsEditing] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null);
  const [confirmDialog, setConfirmDialog] = useState(false);
  const [uploadedImages, setUploadedImages] = useState([]);
  const [clearImages, setClearImages] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [existingImages, setExistingImages] = useState([]);

  useEffect(() => {
    dispatch(getAllCategory());
  }, [dispatch]);

  const [formData, setFormData] = useState({
    productName: "",
    category: [],
    priceAndQuantity: [],
    shortDescription: "",
    detailedDescription: "",
    updatedAt: "",
    sku: "",
    featured: "No",
    returnable: "No",
    status: "Published",
  });
  const [priceData, setPriceData] = useState({
    quantity: "",
    weight: "g",
    price: "",
    discount: "",
    totalCount: "",
    stockAvailability: "Yes",
  });

  // const handleImageChange = (images) => {
  //   const img = images.map((imageObj) => ({ image: imageObj.image }));
  //   setUploadedImages(img);
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     images: img,
  //   }));
  // };

  const handleImageChange = (items) => {
    const newFiles = items
      .filter((it) => it.file instanceof File)
      .map((it) => it.file);
    const existing = items
      .filter((it) => !(it.file instanceof File))
      .map((it) => it.image);

    setUploadedFiles(newFiles); // files to upload
    setExistingImages(existing); // urls from db

    // For display/preview
    const img = [
      ...existing.map((image) => ({ image, type: "existing" })),
      ...newFiles.map((file) => ({
        image: URL.createObjectURL(file),
        type: "new",
      })),
    ];

    setUploadedImages(img);

    // Only existing URLs go into formData.images
    setFormData((prev) => ({ ...prev, images: existing }));
  };

  useEffect(() => {
    if (selectedProductRow && Object.keys(selectedProductRow).length > 0) {
      setUploadedImages(
        Array.isArray(selectedProductRow.images)
          ? selectedProductRow.images
          : []
      );
      setFormData({
        // images: selectedProductRow.images?.image || [],
        productName: selectedProductRow.productName || "",
        category: selectedProductRow.underCategory || [],
        priceAndQuantity: Array.isArray(selectedProductRow.priceAndQuantity)
          ? selectedProductRow.priceAndQuantity
          : [],
        // createdBy: sellerId,
        shortDescription:
          selectedProductRow.description?.shortDescription || "",
        detailedDescription:
          selectedProductRow.description?.detailedDescription || "",
        sku: selectedProductRow.sku || "",
        // updatedAt: selectedProductRow.updatedAt,
        status: selectedProductRow.status || "Published",
        isFeatured: selectedProductRow.featured || "No",
        isReturnable: selectedProductRow.returnable || "No",
      });
      setIsEditing(true);
    } else {
      resetForm();
    }
  }, [selectedProductRow]);

  const handleEditPriceData = (item, index) => {
    const quantityWithUnit = item.quantity || "";
    const weightWithUnit = item.weight || "g";

    const [quantityNumber] = quantityWithUnit.split(/(\D+)/).filter(Boolean);
    const [weightNumber] = weightWithUnit.split(/(\D+)/).filter(Boolean);
    // const [quantityNumber] = item.quantity.split(/(\D+)/).filter(Boolean);
    // const [weightNumber] = item.quantity.split(/(\d+)/).filter(Boolean);

    setPriceData({
      quantity: quantityNumber || "",
      weight: weightNumber || "g",
      price: item.price || "",
      discount: item.discount || "",
      totalCount: item.totalCount || "",
      stockAvailability: item.stockAvailability ? "Yes" : "No",
    });
    setEditingIndex(index);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handlePriceData = (e) => {
    const { name, value } = e.target;
    setPriceData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const addPriceData = () => {
    if (
      priceData.quantity &&
      priceData.weight &&
      priceData.price &&
      priceData.totalCount &&
      priceData.stockAvailability
    ) {
      const combinedQuantity = `${priceData.quantity} - ${priceData.weight}`;
      const newPriceData = {
        price: priceData.price,
        quantity: combinedQuantity,
        discount: priceData.discount,
        totalCount: priceData.totalCount,
        stockAvailability: priceData.stockAvailability === "Yes" ? true : false,
      };
      setFormData((prevFormData) => {
        const updatedPriceAndQuantity = [...prevFormData.priceAndQuantity];
        if (editingIndex !== null) {
          // Update the existing row
          updatedPriceAndQuantity[editingIndex] = newPriceData;
          setEditingIndex(null); // Reset the editing index after updating
        } else {
          // Add new row
          updatedPriceAndQuantity.push(newPriceData);
        }

        return {
          ...prevFormData,
          priceAndQuantity: updatedPriceAndQuantity,
        };
      });

      setPriceData({
        quantity: "",
        weight: "g",
        price: "",
        discount: "",
        totalCount: "",
        stockAvailability: "Yes",
      });
    } else {
      toast.error("Please fill all fields");
    }
  };
  const handleProductSubmit = async (e) => {
    e.preventDefault();

    // Separate existing (filenames) and new (File objects)
    const existing = existingImages; // e.g. ["abc.jpg", "xyz.png"]
    const files = uploadedFiles; // File objects selected from input

    // Prepare product payload
    const productPayload = {
      productName: formData.productName,
      underCategory: formData.category,
      priceAndQuantity: formData.priceAndQuantity,
      createdBy: sellerId,
      sellerName: user.userName,
      description: {
        shortDescription: formData.shortDescription,
        detailedDescription: formData.detailedDescription,
      },
      sku: formData.sku,
      status: formData.status,
      isFeatured: formData.featured === "Yes",
      isReturnable: formData.returnable === "Yes",
      images: existing, // keep already saved ones
    };

    // If there are new files, use FormData
    const formDataToSend = new FormData();
    formDataToSend.append("productData", JSON.stringify(productPayload));
    files.forEach((file) => formDataToSend.append("images", file));

    try {
      if (isEditing) {
        setConfirmDialog(true);
      } else {
        // dispatch with FormData (backend must handle multipart)
        await dispatch(addNewProduct(sellerId, formDataToSend));
        resetForm();
        setShowForm(false);
        setUploadedImages([]);
        setClearImages(true);
      }
    } catch (error) {
      console.error("Error in adding product:", error);
    }
  };

  const editProductConfirm = () => {
    const productid = selectedProductRow.id;

    // ✅ Build product payload JSON
    const productPayload = {
      images: existingImages, // from state (only DB filenames)
      productName: formData.productName,
      underCategory: formData.category,
      priceAndQuantity: formData.priceAndQuantity.map((item) => {
        if (item.quantity === priceData.quantity) {
          return {
            ...item,
            price: priceData.price,
            discount: priceData.discount,
            totalCount: priceData.totalCount,
            stockAvailability: priceData.stockAvailability === "Yes",
          };
        }
        return item;
      }),
      createdBy: sellerId,
      sellerName: user.userName,
      description: {
        shortDescription: formData.shortDescription,
        detailedDescription: formData.detailedDescription,
      },
      sku: formData.sku,
      status: formData.status,
      isFeatured: formData.featured === "Yes",
      isReturnable: formData.returnable === "Yes",
    };

    // ✅ Wrap JSON + new files in FormData
    const formDataToSend = new FormData();
    formDataToSend.append("productData", JSON.stringify(productPayload));
    uploadedFiles.forEach((file) => formDataToSend.append("images", file));

    // ✅ Dispatch API call
    dispatch(editProduct(sellerId, formDataToSend, productid))
      .then(() => {
        resetForm();
        setShowForm(false);
        setClearImages(true);
        dispatch(clearData());
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const handleClose = () => {
    resetForm();
    setShowForm(false);
    setConfirmDialog(false);
    setUploadedImages([]);
    setClearImages(true);
  };

  const resetForm = () => {
    setPriceData({
      quantity: "",
      weight: "g",
      price: "",
      discount: "",
      totalCount: "",
      stockAvailability: "Yes",
    });
    setFormData({
      productName: "",
      category: [],
      priceAndQuantity: [],
      shortDescription: "",
      detailedDescription: "",
      sku: "",
      featured: "No",
      returnable: "No",
      status: "Published",
      updatedAt: "",
    });
    setIsEditing(false);
  };

  return (
    <>
      <div className="m-3">
        <h5>{isEditing ? "Edit Product" : "Add Product"}</h5>
        <div style={{ padding: "25px" }}>
          <form>
            <div className="row">
              <div className="col-12">
                <label htmlFor="Image">
                  Image<span style={{ color: "red" }}>*</span>
                </label>
                <ImageUpload
                  onImagesChange={handleImageChange}
                  clearImages={clearImages}
                  isEditing={isEditing}
                  currentImages={selectedProductRow?.images}
                  allowMultiple={true}
                  folder={process.env.REACT_APP_PRODUCT_PATH} // 👈 pass folder
                />
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-md-6 col-sm-12">
                <label htmlFor="productName">
                  Product Name<span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  id="productName"
                  name="productName"
                  value={formData.productName}
                  onChange={handleChange}
                  className="form-control mb-3"
                  style={{ border: "1px solid #cccccc" }}
                  required
                />
              </div>
              <div className="col-md-6 col-sm-12">
                <label htmlFor="category">
                  Category <span style={{ color: "red" }}>*</span>
                </label>
                <Select
                  className="form-select"
                  labelId="demo-multiple-checkbox-label"
                  id="category"
                  multiple
                  required
                  value={
                    Array.isArray(formData.category)
                      ? formData.category.map((cat) => cat.category)
                      : []
                  }
                  onChange={(e) => {
                    const selectedCategories = e.target.value;
                    const newCategories = selectedCategories.map(
                      (selectedCategory) => {
                        const categoryObj = allCategory.categories.find(
                          (cat) => cat.category === selectedCategory
                        );
                        return {
                          _id: categoryObj._id,
                          category: categoryObj.category,
                        };
                      }
                    );
                    setFormData((prevData) => ({
                      ...prevData,
                      category: newCategories,
                    }));
                  }}
                  input={<OutlinedInput label="Category" />}
                  renderValue={(selected) => selected.join(", ")}
                  style={{ maxHeight: "40px" }}
                >
                  {allCategory.categories &&
                  allCategory.categories.length > 0 ? (
                    allCategory.categories.map((category) => (
                      <MenuItem key={category._id} value={category.category}>
                        <Checkbox
                          checked={
                            Array.isArray(formData.category) &&
                            formData.category.some(
                              (cat) => cat.category === category.category
                            )
                          }
                        />
                        <ListItemText primary={category.category} />
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem disabled>No categories available</MenuItem>
                  )}
                </Select>
              </div>
            </div>
            <div className="row">
              <h5 className="text-center">Price and Quantity</h5>
              <div className="col-md-3 col-sm-12">
                <label htmlFor="quantity">
                  Quantity <span style={{ color: "red" }}>*</span>
                </label>
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    id="quantity"
                    name="quantity"
                    value={priceData.quantity}
                    onChange={handlePriceData}
                    required
                  />
                  <div className="col-auto">
                    <select
                      required
                      className="form-select"
                      name="weight"
                      value={priceData.weight}
                      onChange={handlePriceData}
                    >
                      <option value="g">g</option>
                      <option value="kg">Kg</option>
                      <option value="ml">ml</option>
                      <option value="l">l</option>
                      <option value="piece">piece</option>
                      <option value="big">big</option>
                      <option value="medium">medium</option>
                      <option value="small">small</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="col-md-2 col-sm-12">
                <label htmlFor="price">
                  Price <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  id="price"
                  name="price"
                  value={priceData.price}
                  onChange={handlePriceData}
                  className="form-control mb-3"
                  style={{ border: "1px solid #cccccc" }}
                  required
                />
              </div>

              <div className="col-md-2 col-sm-12">
                <label htmlFor="discount">Discount</label>
                <input
                  type="text"
                  id="discount"
                  name="discount"
                  value={priceData.discount}
                  onChange={handlePriceData}
                  className="form-control mb-3"
                  style={{ border: "1px solid #cccccc" }}
                  required
                />
              </div>
              <div className="col-md-2 col-sm-12">
                <label htmlFor="totalCount">
                  Total Count <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  id="totalCount"
                  name="totalCount"
                  value={priceData.totalCount}
                  onChange={handlePriceData}
                  className="form-control mb-3"
                  style={{ border: "1px solid #cccccc" }}
                  required
                />
              </div>
              <div className="col-md-2 col-sm-12">
                <label htmlFor="stockAvailability">
                  Stock Availability<span style={{ color: "red" }}>*</span>
                </label>
                <select
                  required
                  id="stockAvailability"
                  name="stockAvailability"
                  className="form-select"
                  value={priceData.stockAvailability}
                  onChange={handlePriceData}
                >
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </div>
              <div className="col-md-1 col-sm-12 d-flex align-items-center">
                <button
                  className="btn"
                  style={{ background: "#2b6930", color: "#fff" }}
                  onClick={addPriceData}
                >
                  Add
                </button>
              </div>
            </div>
            {formData.priceAndQuantity &&
              formData.priceAndQuantity.length > 0 && (
                <div className="row mt-5 mb-5 border">
                  {formData.priceAndQuantity.map((item, index) => (
                    <div className="col-12" key={index}>
                      <div className="row mt-3">
                        <div className="col-auto">
                          <strong>Quantity:</strong> {item.quantity},
                        </div>
                        <div className="col-auto">
                          <strong>Price:</strong> {item.price},
                        </div>
                        <div className="col-auto">
                          <strong>Discount:</strong>{" "}
                          {item.discount ? item.discount : "No discount"},
                        </div>
                        <div className="col-auto">
                          <strong>Total Count:</strong> {item.totalCount},
                        </div>
                        <div className="col-auto">
                          <strong>Stock Availability:</strong>{" "}
                          {item.stockAvailability ? "Yes" : "No"},
                        </div>
                        {isEditing && (
                          <div className="col-auto ">
                            <button
                              className="btn"
                              type="button"
                              style={{ background: "#2b6930", color: "#fff" }}
                              onClick={() => handleEditPriceData(item, index)}
                            >
                              Edit
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              )}

            <div className="row">
              <h5 className="text-center">Description</h5>
              <div className="col-12">
                <label htmlFor="shortDescription">
                  Short Description <span style={{ color: "red" }}>*</span>
                </label>
                <div className="form-floating">
                  <textarea
                    required
                    className="form-control"
                    id="shortDescription"
                    name="shortDescription"
                    value={formData.shortDescription}
                    onChange={handleChange}
                    style={{ height: "100px" }}
                  ></textarea>
                </div>
              </div>
              <div className="col-12 mt-2">
                <label htmlFor="detailedDescription">
                  Detailed Description <span style={{ color: "red" }}>*</span>
                </label>
                <div className="form-floating">
                  <textarea
                    required
                    className="form-control"
                    id="detailedDescription"
                    name="detailedDescription"
                    value={formData.detailedDescription}
                    onChange={handleChange}
                    style={{ height: "100px" }}
                  ></textarea>
                </div>
              </div>
            </div>
            <div className="row mt-3">
              {/* <div className="col-md-4 col-sm-12">
                <label htmlFor="sku">Stock Keeping Unit (SKU)</label>
                <input
                  type="text"
                  id="sku"
                  name="sku"
                  value={formData.sku}
                  onChange={handleChange}
                  className="form-control mb-3"
                  style={{ border: "1px solid #cccccc" }}
                  required
                />
              </div> */}
               <div className="col-md-4 col-sm-12">
                <label htmlFor="returnable">
                  Returnable <span style={{ color: "red" }}>*</span>
                </label>
                <select
                  required
                  className="form-select"
                  id="returnable"
                  name="returnable"
                  value={formData.returnable}
                  onChange={handleChange}
                >
                  <option value="No">No</option>
                  <option value="Yes">Yes</option>
                </select>
              </div>
              <div className="col-md-4 col-sm-12">
                <label htmlFor="featured">
                  Featured <span style={{ color: "red" }}>*</span>
                </label>
                <select
                  required
                  className="form-select"
                  id="featured"
                  name="featured"
                  value={formData.featured}
                  onChange={handleChange}
                  disabled
                >
                  <option value="No">No</option>
                  <option value="Yes">Yes</option>
                </select>
              </div>
              <div className="col-md-4 col-sm-12">
                <label htmlFor="status">
                  Status <span style={{ color: "red" }}>*</span>
                </label>
                <select
                  required
                  className="form-select"
                  name="status"
                  id="status"
                  value={formData.status}
                  onChange={handleChange}
                >
                  <option value="Published">Published</option>
                  {/* <option value='Draft'>Draft</option> */}
                  <option value="Out Of Stock">Out Of Stock</option>
                </select>
              </div>
            </div>
            <div className="row mt-3">
              <div className="d-grid gap-2 col-6 mx-auto">
                <button
                  className="btn"
                  style={{ background: "#2b6930", color: "#fff" }}
                  onClick={handleProductSubmit}
                >
                  Submit
                </button>
              </div>
              <div className="d-grid gap-2 col-6 mx-auto">
                <button
                  className="btn"
                  style={{ background: "#C0000B", color: "#fff" }}
                  onClick={handleClose}
                >
                  Cancel
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <ConfirmationDialog
        open={confirmDialog}
        onClose={handleClose}
        onConfirm={editProductConfirm}
        description="Are you sure you want to save these changes?"
      />
    </>
  );
};

export default AddProduct;
